import * as React from 'react';
import Image from 'common/components/Image';
import Copyright from '../Copyright';
import * as intl from 'react-intl-universal';
import { CopyrightConfig } from '../type';
import { Row, Col } from 'antd';

interface iProps {
    size?: 'mini' | 'small' | 'middle' | 'large';
    title?: string;
    description?: Array<string | JSX.Element>;
    link?: JSX.Element;
    logo?: {
        url?: { [key: string]: string };
        alt?: string;
        href?: string;
        loginUrl?: { [key: string]: string };
    };
    className?: string;
    shortcut?: JSX.Element;
    copyright?: CopyrightConfig;
    config?: Array<string>;
    step?: number;
    design?: any;
    type?: string;
    website?: JSX.Element;
    centerType?: string;
}

export default class Layout extends React.Component<iProps> {
    /**
     * 获取背景图样式
     * @param design
     * @param {string} type
     */
    getDesignStyle = (design: any = {}, type?: string) => ({
        backgroundSize: 'cover',
        backgroundImage: design.bgImg ? `url('${design.bgImg}')` : type == 'column' ?
            'linear-gradient(120deg, #94c2e4, #5992c8)' : ''
    });

    state = {
        loginMark: true
    };

    componentDidMount() {
        if ((window.location.href.indexOf('Recovery') !== -1)) {
            this.setState({
                loginMark: false
            });
        }
    }

    render() {
        const { size, title, description = [], link, logo = {}, shortcut, copyright, className, config, step, design, type, website, centerType = '' } = this.props;
        const defaultLogo = window.config.img_file('/images/default_logo.png');
        const { loginMark } = this.state;
        logo.href = null;
        switch (type || 'oldStyle') {
        case 'default' :
            return (
                <div className={`Login-default Login-wrapper ${centerType === 'logoPosition' && 'Login-top-logo'}`}>
                    <div className="Login-background" style={this.getDesignStyle(design)}/>
                    <div className={loginMark ? 'Avoid-shake' : ''}>
                        <div className={`Login-panel ${className || ''}`}>
                            {title && <div className="Login-pane Login-sider">
                                <div className="logo">
                                    {logo.href ?
                                        <a href={logo.href} target="_blank"><Image url={logo.url} alt={logo.alt}
                                                                                   fallbackUrl={defaultLogo}/></a> :
                                        <Image url={logo.url} alt={logo.alt} fallbackUrl={defaultLogo}/>
                                    }
                                </div>
                                <div className="Login-sider-title">{title}</div>
                                <div className="Login-sider-description">
                                    {description.map((item: string, index: number) =>
                                        typeof (item) === 'string' ? <p key={index}>{item}</p> : item)}
                                </div>
                                {config ? <div className="Login-sider-step">
                                    {config.map((value: string, index: number) => value !== "Completed"
                                        ? <div className="step-box"
                                               style={{ backgroundColor: index <= step ? "#6fe8ff" : "#fff" }}
                                               key={index}/>
                                        : null)}
                                </div> : null}
                                <div className="Login-sider-website">{website}</div>
                                <div className="Login-sider-extra">{link}</div>
                            </div>}
                            <div className="Login-pane Login-content">
                                <Row>
                                    <Col span={24}>
                                        <div className="Login-body-core Login-body-header">
                                            {this.props.children}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                    {size !== 'mini' && <Copyright {...(copyright || {})}/>}
                </div>
            );
        case 'left_column':
            return (
                <div className="Login-leftColumn Login-wrapper">
                    <div className="Login-background" style={this.getDesignStyle(design, 'column')}/>
                    <div className='Login-column'>
                        <Row>
                            <Col span={10}>
                                <div className='Login-panel'>
                                    <div className='Login-body-core'>
                                        {this.props.children}
                                    </div>
                                </div>
                            </Col>
                            <Col span={10} offset={4}>
                                <div className='Login-column-right'>
                                    <div className="logo">
                                        {logo.href ?
                                            <a href={logo.href} target="_blank"><Image url={logo.url} alt={logo.alt}
                                                                                       fallbackUrl={defaultLogo}/></a> :
                                            <Image url={logo.url} alt={logo.alt} fallbackUrl={defaultLogo}/>
                                        }
                                    </div>
                                    <div className='Login-text'>
                                        <div dangerouslySetInnerHTML={{ __html: design.text }}/>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            );
        case 'right_column':
            return (
                <div className="Login-rightColumn Login-wrapper">
                    <div className="Login-background" style={this.getDesignStyle(design, 'column')}/>
                    <div className='Login-column'>
                        <Row>
                            <Col span={10}>
                                <div className='Login-column-right'>
                                    <div className="logo">
                                        {logo.href ?
                                            <a href={logo.href} target="_blank"><Image url={logo.url} alt={logo.alt}
                                                                                       fallbackUrl={defaultLogo}/></a> :
                                            <Image url={logo.url} alt={logo.alt} fallbackUrl={defaultLogo}/>
                                        }
                                    </div>
                                    <div className='Login-text'>
                                        <div dangerouslySetInnerHTML={{ __html: design.text }}/>
                                    </div>
                                </div>
                            </Col>
                            <Col span={10} offset={4}>
                                <div className='Login-panel'>
                                    <div className='Login-body-core'>
                                        {this.props.children}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            );
        case 'center' :
            return (
                <div className={`Login-center Login-wrapper ${centerType !== 'logoNormal' && 'Login-top-logo'}`}>
                    <div className="Login-background" style={this.getDesignStyle(design)}/>
                    {
                        centerType !== 'logoNormal' && logo.url && <div className="Login-logo">
                            {logo.href ?
                                <a href={logo.href} target="_blank"><Image url={logo.loginUrl || logo.url}
                                                                           alt={logo.alt}
                                                                           fallbackUrl={defaultLogo}/></a> :
                                <Image url={logo.loginUrl || logo.url} alt={logo.alt} fallbackUrl={defaultLogo}/>
                            }
                        </div>
                    }
                    <div className={loginMark ? 'Avoid-shake' : ''}>
                        <div className={`Login-panel ${className || ''}`}>
                            <div className="Login-ssl">
                                <img src={window.config.img_file('/images/icon_SSL.png')} alt=""/>
                                <p>High risks shall ensue with derivative products investments, e.g. stocks, futures,
                                    forex and CFDs, the losses of which could be more than your investments and may not
                                    be
                                    suitable for all investors. We highly recommend you to seek independent professional
                                    advice before your investments.</p>
                            </div>
                            {title && <div className="Login-pane Login-sider">
                                {centerType === 'logoNormal' && <div className="logo">
                                    {logo.href ?
                                        <a href={logo.href} target="_blank"><Image url={logo.url} alt={logo.alt}
                                                                                   fallbackUrl={defaultLogo}/></a> :
                                        <Image url={logo.url} alt={logo.alt} fallbackUrl={defaultLogo}/>
                                    }
                                </div>}
                                <div className="Login-sider-title">{title}</div>
                                <div className="Login-sider-description">
                                    {description.map((item: string, index: number) =>
                                        typeof (item) === 'string' ? <p key={index}>{item}</p> : item)}
                                </div>
                                {config ? <div className="Login-sider-step">
                                    {config.map((value: string, index: number) => value !== "Completed"
                                        ? <div className="step-box"
                                               style={{ backgroundColor: index <= step ? "#d90000" : "#fff" }}
                                               key={index}/>
                                        : null)}
                                </div> : null}
                                {
                                    centerType !== 'retrunLogin' ?
                                        <div className="Login-sider-website">{website}</div> :
                                        <div className="Login-sider-website">{link}</div>
                                }
                                <div className="Login-sider-protect">
                                    <img src={window.config.img_file('/images/icon_safe.png')} alt=""/>
                                    <p>{intl.get('SignUp.HintProtectInfo')}</p>
                                </div>
                            </div>}
                            <div className="Login-pane Login-content">
                                <Row>
                                    <Col span={24}>
                                        <div className="Login-body-core Login-body-header">
                                            {this.props.children}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                    {size !== 'mini' && <Copyright {...(copyright || {})}/>}
                </div>
            );
        default:
            return (
                <div className="Login-wrapper">
                    <div className="Login-background" style={this.getDesignStyle(design)}/>
                    <div className={`Login-panel Login-panel-${size || 'small'} ${className || ''}`}>
                        {title && <div className="Login-pane Login-sider">
                            <div className="logo">
                                {logo.href ?
                                    <a href={logo.href} target="_blank"><Image url={logo.url} alt={logo.alt}
                                                                               fallbackUrl={defaultLogo}/></a> :
                                    <Image url={logo.url} alt={logo.alt} fallbackUrl={defaultLogo}/>
                                }
                            </div>
                            <div className="Login-sider-title">{title}</div>
                            <div className="Login-sider-description">
                                {description.map((item: string, index: number) =>
                                    typeof (item) === 'string' ? <p key={index}>{item}</p> : item)}
                            </div>
                            {config ? <div className="Login-sider-step">
                                {config.map((value: string, index: number) => value !== "Completed"
                                    ? <div className="step-box"
                                           style={{ backgroundColor: index <= step ? "#4e72b8" : "#fff" }}
                                           key={index}/>
                                    : null)}
                            </div> : null}
                            <div className="Login-sider-website">{website}</div>
                            <div className="Login-sider-extra">{link}</div>
                        </div>}
                        <div className="Login-pane Login-content">
                            <Row>
                                <Col span={20} offset={2}>
                                    <div className="Login-body-header">
                                        <div className="shortcut">{shortcut}</div>
                                    </div>
                                    <div className="Login-body-core">
                                        {this.props.children}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    {size !== 'mini' && <Copyright {...(copyright || {})}/>}
                </div>
            );
        }
    }
}
